export var InputControlType;
(function (InputControlType) {
    InputControlType[InputControlType["INPUT"] = 0] = "INPUT";
    InputControlType[InputControlType["TEXTAREA"] = 1] = "TEXTAREA";
    InputControlType[InputControlType["DROPDOWN"] = 2] = "DROPDOWN";
    InputControlType[InputControlType["RADIO"] = 3] = "RADIO";
    InputControlType[InputControlType["CHECKBOX"] = 4] = "CHECKBOX";
    InputControlType[InputControlType["NAME"] = 5] = "NAME";
    InputControlType[InputControlType["GUEST_CONTROL"] = 6] = "GUEST_CONTROL";
    InputControlType[InputControlType["ADDRESS_SHORT"] = 7] = "ADDRESS_SHORT";
    InputControlType[InputControlType["ADDRESS_FULL"] = 8] = "ADDRESS_FULL";
    InputControlType[InputControlType["DATE"] = 9] = "DATE";
})(InputControlType || (InputControlType = {}));
export var ValueType;
(function (ValueType) {
    ValueType[ValueType["TEXT"] = 0] = "TEXT";
    ValueType[ValueType["NUMBER"] = 1] = "NUMBER";
    ValueType[ValueType["TEXT_ARRAY"] = 2] = "TEXT_ARRAY";
    ValueType[ValueType["DATE_TIME"] = 3] = "DATE_TIME";
    ValueType[ValueType["ADDRESS"] = 4] = "ADDRESS";
})(ValueType || (ValueType = {}));
//# sourceMappingURL=form.js.map